function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as Yup from 'yup';
export var isValidEmail = function(str) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(str);
};
export var validEmailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export var validEmailDomainRegex = /^[A-Z0-9.-]+\.[A-Z]{2,}$/i;
// Only accept valid emails that have a domain different from gmail, hotmail, icloud, and outlook.
export var nonPersonalEmailRegex = /^[A-Z0-9._%+-]+@(?!gmail\.|hotmail\.|icloud\.|outlook\.)[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
// Only accept letters (including French accents), dash, and apostrophes
export var validFirstNameRegex = /^([a-zA-Z-À-ÿ]|'|-)+$/;
// Accept letters (including French accents), dash, apostrophes and spaces
export var validLastNameRegex = /^[a-zA-ZÀ-ÿ]+(?:['\s-][a-zA-ZÀ-ÿ]+)*$/;
// Accept letters (including French accents), dash, apostrophes and spaces
export var validTitleRegex = /[a-zA-Z\-'\S]+/g;
// Should have minimum 6 characters, 1 number, 1 lowercase and 1 uppercase letter
export var validPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.{6,})/;
// Should have minimum 6 characters, 1 number and 1 special character
export var validPasswordSpecialCharRegex = /^(?=.*\d)(?=.*[!@#$%^&*()_?,./\\|]).{6,}$/;
// Accept dates in the format MM/DD/YYYY
export var validMedDateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;
export var acceptedImgTypes = 'image/jpeg, image/jpg, image/png';
export var validateSIN = function(sin) {
    if (!sin || (sin === null || sin === void 0 ? void 0 : sin.charAt(0)) === '0' || (sin === null || sin === void 0 ? void 0 : sin.charAt(0)) === '8') {
        return false;
    }
    var sum = 0;
    for(var i = 0; i < sin.length; i += 1){
        var n = parseInt(sin.charAt(i), 10);
        if (i % 2 === 0) {
            sum += n;
        } else {
            var x = 2 * n;
            sum += x > 9 ? x - 9 : x;
        }
    }
    return sum % 10 === 0;
};
export var validateSSN = function(ssn) {
    // Check if the SSN is 9 digits long
    if (!ssn || ssn.length !== 9) {
        return false;
    }
    // Check if the SSN is in the correct format
    var regex = /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/;
    return regex.test(ssn);
};
function generateFormFields() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    return Object.fromEntries(keys.map(function(k) {
        return [
            k,
            ''
        ];
    }));
}
var extraValidationDefault = {
    subjectMaxLimit: 100
};
export var basicUserInfoFormValidation = function(i18n, fields, extraValidation) {
    var _extraValidation_subjectMaxLimit;
    var subjectMaxLimit = (_extraValidation_subjectMaxLimit = extraValidation === null || extraValidation === void 0 ? void 0 : extraValidation.subjectMaxLimit) !== null && _extraValidation_subjectMaxLimit !== void 0 ? _extraValidation_subjectMaxLimit : extraValidationDefault.subjectMaxLimit;
    var formFields = {
        firstName: Yup.string().max(50, i18n.t('common.form.firstName.maxError')).required(i18n.t('common.form.firstName.requiredError')).matches(validFirstNameRegex, i18n.t('common.form.firstName.matchesError')),
        lastName: Yup.string().max(100, i18n.t('common.form.lastName.maxError')).required(i18n.t('common.form.lastName.requiredError')).matches(validLastNameRegex, i18n.t('common.form.lastName.matchesError')),
        subject: Yup.string().min(2, i18n.t('common.form.errors.minError', {
            count: 2
        })).max(subjectMaxLimit, i18n.t('common.form.errors.maxError', {
            count: subjectMaxLimit
        })).required(i18n.t('common.form.errors.requiredError', {
            label: i18n.t('common.form.subject.label').toLowerCase()
        })).matches(validTitleRegex, i18n.t('common.form.subject.matchesError')),
        textarea: Yup.string().min(2, i18n.t('common.form.errors.minError', {
            count: 2
        })).required(i18n.t('common.form.errors.requiredError', {
            label: i18n.t('common.form.description.label').toLowerCase()
        })),
        email: Yup.string().required(i18n.t('common.form.email.requiredError')).test('email-domain', i18n.t('common.form.email.sameDomain'), function() {
            var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
            var _extraValidation_email, _extraValidation_email1;
            return !(extraValidation === null || extraValidation === void 0 ? void 0 : (_extraValidation_email = extraValidation.email) === null || _extraValidation_email === void 0 ? void 0 : _extraValidation_email.sameDomain) ? true : !value.includes('@') && (extraValidation === null || extraValidation === void 0 ? void 0 : (_extraValidation_email1 = extraValidation.email) === null || _extraValidation_email1 === void 0 ? void 0 : _extraValidation_email1.sameDomain);
        }),
        password: Yup.string().required(i18n.t('common.form.password.error')),
        phoneNumberCognito: Yup.string().required(i18n.t('common.form.phone.requiredError')).min(12, i18n.t('common.form.phone.invalidError'))
    };
    var formFieldsFiltered = generateFormFields.apply(void 0, _to_consumable_array(fields));
    fields.forEach(function(field) {
        formFieldsFiltered[field] = formFields[field];
    });
    return _object_spread({}, formFieldsFiltered);
};
export var locationValidation = Yup.object().shape({
    addressLine1: Yup.string().nullable(),
    addressLine2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    province: Yup.string().nullable(),
    postalCode: Yup.string().ensure().nullable(),
    countryCode: Yup.string().nullable(),
    country: Yup.string().nullable(),
    latitude: Yup.string().nullable(),
    longitude: Yup.string().nullable()
}).nullable();
export var validateDemoPortalEmailDomain = function(value, allowedDomains) {
    var shouldValidate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!value || !shouldValidate) return true;
    try {
        var emailDomain = value.split('@')[1];
        return emailDomain && allowedDomains ? allowedDomains.includes(emailDomain) : false;
    } catch (err) {
        return false;
    }
};
